import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Info",
  "use": "Info-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol class=\"vertical-align-middle display-inline-block\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"Info\">\n  <path fill=\"currentColor\" class=\"st0\" d=\"M6.6,4.2H5.4V3h1.2V4.2z M6.6,9H5.4V5.4h1.2V9z M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol